import { faBars, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import { appDomain } from "../../domain/AppDomain";
import { IMenuItem } from "../../domain/appMenu/IMenuItem";
import headerLogo from "../../images/header-logo.jpg";
import { BaseComponent } from "./BaseComponent";
import "./NavMenu.css";

interface NavMenuItemProps {
    index: number;
    menuItem: IMenuItem;
}

export class NavMenuItem extends BaseComponent<NavMenuItemProps> {
    render() {
        const menuItem = this.props.menuItem;
        const activeClass = "item " + (window.location.hash.startsWith(`#${menuItem.routeName}`) ? "active" : "");
        return <div className={activeClass}>
            <Link to={menuItem.routeName} onClick={() => menuItem.click()}>{this.translate(menuItem.name)}</Link>
        </div >
    }
}

interface NavMenuState {
    showMenu: boolean;
    menuItems: IMenuItem[];
    userName: string;
    windowWidth: number;
}

export class NavMenu extends BaseComponent<{}, NavMenuState> {
    constructor(props: {}) {
        super(props);
        this.state = { showMenu: false, menuItems: [], userName: "", windowWidth: window.innerWidth };
    }

    componentDidMount() {
        const menuItems = appDomain.IRequestMenuItems.getAll();
        const userName = appDomain.IAuthenticationService.getUserName();

        this.setStateWhenMounted({ showMenu: false, menuItems, userName, windowWidth: window.innerWidth });

        this.addEventListener(window, "resize", this.windowResize.bind(this));
        this.addEventListener(window, "click", this.windowClick.bind(this));
    }

    windowClick() {
        this.setStateWhenMounted({ showMenu: false });
    }

    windowResize() {
        this.setStateWhenMounted({ showMenu: false, windowWidth: window.innerWidth });
    }

    toggleMenu(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.setStateWhenMounted({ showMenu: !this.state.showMenu })
    }

    getMenu(): JSX.Element {
        const classes = ["nav-menu", "all-menu-items"];
        const isMobile = this.getIsMobile();
        if (isMobile) classes.push("mobile");

        const items: JSX.Element[] = [];
        this.state.menuItems.forEach((mi, i) => items.push(<NavMenuItem key={`menu-${i}`} index={i} menuItem={mi} />));
        return (<div key="menu-item-key" className={classes.join(" ")}>
            <div className="items group">
                {items}
                <div className="user-name"><FontAwesomeIcon icon={faUser} /> {this.state.userName}</div>
            </div>
        </div>)
    }

    private getIsMobile() {
        return this.state.windowWidth < 900;
    }

    render() {
        let menu: JSX.Element[] = [];
        let menuToggle: JSX.Element[] = [];
        menu = [this.getMenu()];

        const isMobile = this.getIsMobile();
        if (isMobile) {
            menuToggle = [<FontAwesomeIcon key="toggle" icon={faBars} />]
            if (!this.state.showMenu) {
                menu = [];
            }
        }

        return (
            <div className="header">
                <img className="logo" alt="DNA Afwezigheid" src={headerLogo} />
                <div className="nav-menu-toggle" onClick={this.toggleMenu.bind(this)}>
                    {menuToggle}
                    {menu}
                </div>
            </div>
        )
    }
}
